(function inpageAlertsInit() {
    // Check if the module exists before doing anything
    const inpageAlertsExists = !!document.querySelector('.inpage-alerts');

    // If the module exists, do whatever we need to
    if (inpageAlertsExists) {
        // Your code here
    }
})();
